
export interface RecordFormData {
  title: string;
  record_type: string;
  record_date: Date;
  description: string;
  vet_name: string;
}

export interface RecordTypeOption {
  value: string;
  label: string;
}

export const recordTypeOptions: RecordTypeOption[] = [
  { value: 'vaccine_record', label: 'Vaccine Record' },
  { value: 'diagnosis', label: 'Diagnosis' },
  { value: 'treatment', label: 'Treatment' },
  { value: 'surgery', label: 'Surgery' },
  { value: 'medication_log', label: 'Medication Log' },
  { value: 'lab_result', label: 'Lab Result' },
  { value: 'general_note', label: 'General Note' },
];
